(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bottle-glass-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var band = document.querySelector('[data-bottle-glass-band]');
    if (!band) return;
    if (!('IntersectionObserver' in window)) {
      band.classList.add('is-in-view');
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          band.classList.add('is-in-view');
          io.disconnect();
        }
      });
    }, { threshold: 0.2 });
    io.observe(band);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  function mountFestivalWidgetAndDrag() {
    var widgets = Array.prototype.slice.call(document.querySelectorAll('.festival-widget'));
    if (!widgets.length) return;
    var widget = widgets.find(function (el) { return el.dataset.bwwMount !== '1'; }) || widgets[0];
    widgets.forEach(function (el) {
      if (el !== widget) el.remove();
    });
    widget.style.position = 'fixed';
    widget.style.removeProperty('z-index');
    widget.style.removeProperty('top');
    widget.style.removeProperty('right');
    widget.style.removeProperty('bottom');
    widget.style.removeProperty('left');
    if (widget.dataset.bwwMount === '1') return;
    widget.dataset.bwwMount = '1';

    document.body.appendChild(widget);

    // Drag when floating card layout (viewport wider than mobile bar breakpoint)
    (function initFestivalWidgetDrag(el) {
      function isDraggableLayout() {
        return window.matchMedia('(min-width: 769px)').matches;
      }

      el.style.touchAction = 'none';

      var startX;
      var startY;
      var origLeft;
      var origTop;
      var hasMoved;

      function applyMove(clientX, clientY, ev) {
        if (!isDraggableLayout()) return;
        var dx = clientX - startX;
        var dy = clientY - startY;
        if (!hasMoved && Math.abs(dx) < 5 && Math.abs(dy) < 5) return;
        hasMoved = true;
        if (ev && ev.cancelable) ev.preventDefault();
        var nx = Math.max(0, Math.min(window.innerWidth - el.offsetWidth, origLeft + dx));
        var ny = Math.max(0, Math.min(window.innerHeight - el.offsetHeight, origTop + dy));
        el.style.left = nx + 'px';
        el.style.top = ny + 'px';
        el.style.bottom = 'auto';
        el.style.right = 'auto';
      }

      function onMouseMove(e) {
        applyMove(e.clientX, e.clientY, e);
      }

      function onTouchMove(e) {
        if (!e.touches || !e.touches[0]) return;
        applyMove(e.touches[0].clientX, e.touches[0].clientY, e);
      }

      function endDrag() {
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', endDrag);
        document.removeEventListener('touchmove', onTouchMove, true);
        document.removeEventListener('touchend', endDrag);
        document.removeEventListener('touchcancel', endDrag);
        el.classList.remove('is-dragging');
        el.style.transition = '';
        hasMoved = false;
      }

      function onMouseDown(e) {
        if (!isDraggableLayout()) return;
        if (e.button !== 0) return;
        var rect = el.getBoundingClientRect();
        startX = e.clientX;
        startY = e.clientY;
        origLeft = rect.left;
        origTop = rect.top;
        hasMoved = false;
        el.classList.add('is-dragging');
        el.style.transition = 'none';
        e.preventDefault();
        e.stopPropagation();
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', endDrag);
      }

      function onTouchStart(e) {
        if (!isDraggableLayout()) return;
        if (!e.touches || !e.touches[0]) return;
        var rect = el.getBoundingClientRect();
        var t = e.touches[0];
        startX = t.clientX;
        startY = t.clientY;
        origLeft = rect.left;
        origTop = rect.top;
        hasMoved = false;
        el.classList.add('is-dragging');
        el.style.transition = 'none';
        document.addEventListener('touchmove', onTouchMove, { passive: false, capture: true });
        document.addEventListener('touchend', endDrag, { passive: false });
        document.addEventListener('touchcancel', endDrag, { passive: false });
      }

      // Capture phase: run before other theme / app handlers that might stop propagation
      el.addEventListener('mousedown', onMouseDown, true);
      el.addEventListener('touchstart', onTouchStart, { passive: false, capture: true });
    })(widget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountFestivalWidgetAndDrag);
  } else {
    mountFestivalWidgetAndDrag();
  }

  const header = document.querySelector('[data-header]');
  const menuToggle = header && header.querySelector('[data-menu-toggle]');
  const menuClose = header && header.querySelector('[data-menu-close]');
  const mobileNav = header && header.querySelector('[data-mobile-nav]');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => mobileNav.showModal());
  }
  if (menuClose && mobileNav) {
    menuClose.addEventListener('click', () => mobileNav.close());
  }
  if (mobileNav) {
    mobileNav.addEventListener('click', (e) => {
      if (e.target === mobileNav) mobileNav.close();
    });
    mobileNav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => mobileNav.close());
    });
  }

  if (header) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          header.classList.toggle('header--scrolled', window.scrollY > 10);
          ticking = false;
        });
        ticking = true;
      }
    });
  }

  // Countdown timer
  document.querySelectorAll('[data-countdown]').forEach((countdownEl) => {
    if (countdownEl.dataset.countdownInit === '1') return;
    countdownEl.dataset.countdownInit = '1';
    const target = new Date(countdownEl.dataset.countdown).getTime();
    const days = countdownEl.querySelector('[data-days]');
    const hours = countdownEl.querySelector('[data-hours]');
    const mins = countdownEl.querySelector('[data-mins]');
    const secs = countdownEl.querySelector('[data-secs]');

    if (days && hours && mins && secs) {
      function tick() {
        const diff = target - Date.now();
        if (diff <= 0) {
          days.textContent = '00';
          hours.textContent = '00';
          mins.textContent = '00';
          secs.textContent = '00';
          return;
        }
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        days.textContent = String(d).padStart(2, '0');
        hours.textContent = String(h).padStart(2, '0');
        mins.textContent = String(m).padStart(2, '0');
        secs.textContent = String(s).padStart(2, '0');
      }

      tick();
      setInterval(tick, 1000);
    }
  });

  // Logo rotator (desktop + mobile)
  document.querySelectorAll('[data-logo-rotator], [data-mobile-logo-rotator]').forEach(function(rotator) {
    const logos = rotator.querySelectorAll('.header__brand-logo--rotate, .header__mobile-brand-logo--rotate');
    if (logos.length > 0) {
      let current = 0;
      logos[0].classList.add('is-active');
      if (logos.length > 1) {
        setInterval(function() {
          logos[current].classList.remove('is-active');
          current = (current + 1) % logos.length;
          logos[current].classList.add('is-active');
        }, 3000);
      }
    }
  });
  // Sister-festival switcher pill — pop in, shrink on scroll down / grow on scroll up,
  // and float just above the countdown bar (mobile).
  (function () {
    const pill = document.querySelector('[data-festival-pill]');
    if (!pill || pill.dataset.pillInit === '1') return;
    pill.dataset.pillInit = '1';

    const widget = document.querySelector('.festival-widget');

    function positionPill() {
      if (!widget) return;
      const h = widget.getBoundingClientRect().height;
      if (h > 0) pill.style.setProperty('--festival-pill-bottom', h + 'px');
    }

    const NARROW_AT = 100;
    const DELTA = 6;
    let lastY = window.scrollY || window.pageYOffset || 0;
    let ticking = false;

    function update() {
      ticking = false;
      const y = window.scrollY || window.pageYOffset || 0;
      if (y < NARROW_AT) {
        pill.classList.remove('is-narrow');
      } else if (y > lastY + DELTA) {
        pill.classList.add('is-narrow');
      } else if (y < lastY - DELTA) {
        pill.classList.remove('is-narrow');
      }
      lastY = y;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', positionPill, { passive: true });

    positionPill();
    setTimeout(positionPill, 400);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        positionPill();
        pill.classList.add('is-visible');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var btn = document.querySelector('[data-hero-cta]');
    if (btn) {
      btn.addEventListener('click', function (event) {
        var href = btn.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;
        var target = document.querySelector(href);
        if (!target) return;

        event.preventDefault();
        var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({
          behavior: prefersReduced ? 'auto' : 'smooth',
          block: 'start'
        });
        if (history && history.pushState) {
          history.pushState(null, '', href);
        }
      });
    }

    // Mobile parallax — bottle/glass/logo drift at different speeds on scroll
    var hero = document.querySelector('.hero');
    var bottle = document.querySelector('.hero__prop--bottle');
    var glass = document.querySelector('.hero__prop--glass');
    var heroLogo = document.querySelector('.hero__prop--logo');
    if (!hero) return;

    var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobileMQ = window.matchMedia('(max-width: 768px)');
    var ticking = false;

    function update() {
      ticking = false;
      if (prefersReduced || !mobileMQ.matches) {
        if (bottle) bottle.style.removeProperty('--scroll-bottle');
        if (glass) glass.style.removeProperty('--scroll-glass');
        if (heroLogo) heroLogo.style.removeProperty('--scroll-logo');
        return;
      }
      var rect = hero.getBoundingClientRect();
      var y = Math.max(0, -rect.top);
      if (bottle) bottle.style.setProperty('--scroll-bottle', (-y * 0.22) + 'px');
      if (glass) glass.style.setProperty('--scroll-glass', (-y * 0.38) + 'px');
      if (heroLogo) heroLogo.style.setProperty('--scroll-logo', (-y * 0.55) + 'px');
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.currentScript && document.currentScript.closest('.newsletter');
  if (!section) section = document.querySelector('.newsletter');
  if (!section) return;

  if (!('IntersectionObserver' in window)) {
    section.classList.add('newsletter--in');
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        section.classList.add('newsletter--in');
        io.disconnect();
      }
    });
  }, { threshold: 0.2, rootMargin: '0px 0px -5% 0px' });

  io.observe(section);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poster-splash"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.currentScript && document.currentScript.closest('.poster-splash');
  if (!section) section = document.querySelector('.poster-splash');
  if (!section) return;

  var assets = section.querySelectorAll('.ps-asset[data-parallax]');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 749px)').matches;

  if ('IntersectionObserver' in window && !reduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          var idx = Array.prototype.indexOf.call(assets, entry.target);
          setTimeout(function () { entry.target.classList.add('is-in'); }, idx * 80);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
    assets.forEach(function (el) { io.observe(el); });
  } else {
    assets.forEach(function (el) { el.classList.add('is-in'); });
  }

  if (reduced || isMobile) return;

  var ticking = false;
  function update() {
    var rect = section.getBoundingClientRect();
    var vh = window.innerHeight;
    var progress = (vh - rect.top) / (vh + rect.height);
    var offset = (progress - 0.5) * 2;
    assets.forEach(function (el) {
      var speed = parseFloat(el.dataset.parallax) || 0.1;
      el.style.transform = 'translate3d(0,' + (-offset * speed * 120) + 'px,0)';
    });
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-band"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.currentScript && document.currentScript.closest('.video-band');
  if (!section) return;
  var logo = section.querySelector('.video-band__overlay-logo');

  section.querySelectorAll('.video-band__overlay-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var target = document.querySelector(btn.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  if (!logo || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ticking = false;
  function updateLogoFloat() {
    var rect = section.getBoundingClientRect();
    var vh = window.innerHeight;
    var progress = (vh - rect.top) / (vh + rect.height);
    var offset = (progress - 0.5) * 2; /* -1..1 through section */
    var y = Math.max(-14, Math.min(14, offset * 14));
    logo.style.transform = 'translateY(' + y.toFixed(2) + 'px)';
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(updateLogoFloat);
      ticking = true;
    }
  }, { passive: true });

  updateLogoFloat();
})();

  } catch(e) { console.error(e); }
})();
})();
